/* BudBabes PDP enhancements
   1) Pop the gallery bigger when it locks into its sticky spot.
   2) Custom directional gallery cursor + click/tap-to-navigate (arrows removed). */

/* ---------- 1. sticky pop ---------- */
(function () {
  var STICK_TOP = 88;               // must match the `top:` in budbabes-polish.css
  var mq = window.matchMedia('(min-width: 990px)');
  var ticking = false, stuck = false, wrap = null;

  function pick() {
    var els = document.querySelectorAll('.product__media-wrapper.product__column-sticky');
    for (var i = 0; i < els.length; i++) { if (els[i].offsetWidth > 0) return els[i]; }
    return els[0] || null;
  }
  function update() {
    ticking = false;
    if (!wrap || !wrap.isConnected || wrap.offsetWidth === 0) wrap = pick();
    if (!wrap) return;
    if (!mq.matches) { if (stuck) { stuck = false; wrap.classList.remove('bb-stuck'); } return; }
    var nowStuck = wrap.getBoundingClientRect().top <= STICK_TOP + 2;
    if (nowStuck !== stuck) { stuck = nowStuck; wrap.classList.toggle('bb-stuck', nowStuck); }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', onScroll);
  document.addEventListener('DOMContentLoaded', function () { wrap = pick(); update(); });
  wrap = pick(); update();
})();

/* ---------- 2. directional cursor + click/tap navigation ---------- */
(function () {
  function init() {
    var slider = document.querySelector('.product__media-wrapper .product-media-slider');
    if (!slider) return;
    var prevBtn = slider.querySelector('button[name="previous"]');
    var nextBtn = slider.querySelector('button[name="next"]');
    if (!prevBtn || !nextBtn) return;

    slider.classList.add('bb-cursor-nav');   // CSS hides the native arrows only now

    var fine = window.matchMedia('(pointer: fine)');
    var cur = null, tx = 0, ty = 0, cx = 0, cy = 0, raf = null, inside = false;

    function makeCursor() {
      if (cur) return cur;
      cur = document.createElement('div');
      cur.className = 'bb-gcursor';
      cur.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
      document.body.appendChild(cur);
      return cur;
    }
    function loop() {
      cx += (tx - cx) * 0.16; cy += (ty - cy) * 0.16;   // slow follow (lerp)
      cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      if (inside || Math.abs(tx - cx) > 0.4 || Math.abs(ty - cy) > 0.4) raf = requestAnimationFrame(loop);
      else raf = null;
    }
    function side(e) {
      var r = slider.getBoundingClientRect();
      return (e.clientX - r.left) < r.width / 2 ? 'left' : 'right';
    }
    function onMove(e) {
      if (!fine.matches) return;
      makeCursor();
      tx = e.clientX; ty = e.clientY;
      cur.classList.toggle('is-left', side(e) === 'left');
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function onEnter(e) {
      if (!fine.matches) return;
      makeCursor();
      inside = true; cx = tx = e.clientX; cy = ty = e.clientY;
      cur.classList.add('is-visible');
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function onLeave() { inside = false; if (cur) cur.classList.remove('is-visible'); }

    // suppress the click that follows a swipe on touch
    var moved = false, sx = 0, sy = 0;
    slider.addEventListener('touchstart', function (e) {
      moved = false; if (e.touches[0]) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    }, { passive: true });
    slider.addEventListener('touchmove', function (e) {
      if (e.touches[0] && (Math.abs(e.touches[0].clientX - sx) > 8 || Math.abs(e.touches[0].clientY - sy) > 8)) moved = true;
    }, { passive: true });

    /* instantly move the active ring — the theme only updates aria-current after
       its transition, which reads as lag */
    function ring(delta) {
      var wrap = slider.closest('.product__media-wrapper');
      var list = wrap && wrap.querySelector('.thumbnail-list');
      if (!list) return;
      var thumbs = Array.prototype.slice.call(list.querySelectorAll('.thumbnail'));
      if (!thumbs.length) return;
      var cur = list.querySelector('.thumbnail[aria-current]');
      var i = Math.max(0, thumbs.indexOf(cur));
      var next = thumbs[(i + delta + thumbs.length) % thumbs.length];
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      next.setAttribute('aria-current', 'true');
    }

    function onClick(e) {
      if (moved) { moved = false; return; }                 // was a swipe, not a tap
      if (e.target.closest('button, a, model-viewer, .deferred-media__poster-button, .product-media-modal, .thumbnail')) return;
      if (side(e) === 'left') { prevBtn.click(); ring(-1); }
      else { nextBtn.click(); ring(1); }
    }

    slider.addEventListener('mousemove', onMove);
    slider.addEventListener('mouseenter', onEnter);
    slider.addEventListener('mouseleave', onLeave);
    slider.addEventListener('click', onClick);

    // clicking a thumbnail: move the ring immediately (theme re-confirms after)
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.thumbnail-list .thumbnail');
      if (!t) return;
      var list = t.closest('.thumbnail-list');
      list.querySelectorAll('.thumbnail[aria-current]').forEach(function (el) {
        el.removeAttribute('aria-current');
      });
      t.setAttribute('aria-current', 'true');
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
